export default __webpack_public_path__ + "static/media/bags.057e02e3.webp";